import { BaseContainerModel } from '../../base-container.model';
import { bl_cms_activity_highlight_RowClass } from '../../../dbschema';

export class CmsActivityHighlightContainerModel extends BaseContainerModel {
    bl_cms_activity_highlight: bl_cms_activity_highlight_RowClass = new bl_cms_activity_highlight_RowClass();
}
